var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.599,
    height: 28.599,
    viewBox: "0 0 28.599 28.599",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Google__G__Logo",
    "data-name": "Google_ G _Logo",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2382",
    "data-name": "Trac\\xE9 2382",
    d: "M25.727,12.925A16.43,16.43,0,0,0,25.467,10H12v5.538h7.7a6.594,6.594,0,0,1-2.873,4.3v3.6h4.641a13.971,13.971,0,0,0,4.264-10.516Z",
    transform: "translate(3.299 2.699)",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2383",
    "data-name": "Trac\\xE9 2383",
    d: "M14.945,25.669a13.648,13.648,0,0,0,9.464-3.458l-4.641-3.6A8.6,8.6,0,0,1,6.938,14.1H2.18v3.692A14.286,14.286,0,0,0,14.945,25.669Z",
    transform: "translate(0.354 3.929)",
    fill: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2384",
    "data-name": "Trac\\xE9 2384",
    d: "M7.292,16.2a8.339,8.339,0,0,1,0-5.434V7.07H2.534a14.155,14.155,0,0,0,0,12.817L6.239,17,7.292,16.2Z",
    transform: "translate(0 1.821)",
    fill: "#fbbc05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2385",
    "data-name": "Trac\\xE9 2385",
    d: "M14.945,6.694a7.8,7.8,0,0,1,5.473,2.132l4.095-4.095A13.718,13.718,0,0,0,14.945,1,14.274,14.274,0,0,0,2.18,8.891l4.758,3.692a8.537,8.537,0,0,1,8.008-5.889Z",
    transform: "translate(0.354)",
    fill: "#ea4335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2386",
    "data-name": "Trac\\xE9 2386",
    d: "M1,1H29.6V29.6H1Z",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/googleLogo.95d4a6fab9ba1f925046f56bec05c89a.svg";
export { ForwardRef as ReactComponent };